import { render, staticRenderFns } from "./Narvik.vue?vue&type=template&id=be50fae6&"
import script from "./Narvik.vue?vue&type=script&lang=js&"
export * from "./Narvik.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports